<script setup>
import {computed} from 'vue'
import {useLightboxStore} from '@/stores/lightbox'
import {useViewStore} from '@/stores/view'

import ListingNoContent from './ListingNoContent'
import ListingNoContentOptions from './ListingNoContentOptions'
import ListingSelectAll from './ListingSelectAll'
import TableViewHead from './TableViewHead'
import TableViewRow from './TableViewRow'

import vDisableShiftSelect from '@/vue/directives/disableShiftSelect'

const props = defineProps({
    viewId: String
})

const viewStore = useViewStore(props.viewId)
const lightboxStore = useLightboxStore()

const itemCount = computed(() => viewStore.itemCount)
const ids = computed(() => viewStore.ids || [])

lightboxStore.reset()
</script>

<template>
    <div v-disable-shift-select>
        <div v-if="itemCount === 0">
            <ListingNoContent :view-id="viewId"/>
            <ListingNoContentOptions :view-id="viewId"/>
        </div>

        <div v-else class="overflow-scroll">
            <ListingSelectAll :view-id="viewId"/>

            <table class="table table-hover table-dashed">
                <TableViewHead :view-id="viewId"/>

                <tbody class="bg-white">
                <TableViewRow v-for="id in ids" :id="id" :key="id" :view-id="viewId"/>
                </tbody>
            </table>
        </div>
    </div>
</template>